import { useLazyQuery, useQuery } from "@apollo/client";
import {
  SALES_CHANNEL_INPUT_OPTIONS,
  SALES_CHANNEL_WITH_IDS,
  SALES_CHANNEL_WITH_PLATFORM,
} from "graphql/salesChannel/query";
import { sortSaleChannels } from "pages/App/Product/constants";
import { convertOptions } from "./converter";

export const useSalesChannelInputOptions = (params) => {
  const { data, error, loading } = useQuery(SALES_CHANNEL_INPUT_OPTIONS, {
    variables: {
      filters: {},
    },
  });
  return {
    data: data?.saleChannel?.listSalesChannel,
    error,
    loading,
    convertedData: convertOptions(data?.saleChannel?.listSalesChannel),
  };
};

export const useSalesChannelWithIds = (params) => {
  const { data, error, loading } = useQuery(SALES_CHANNEL_WITH_IDS, {
    variables: { filters: { ...params } },
    skip: params?.ids === undefined,
  });

  return {
    data: data?.saleChannel?.listSalesChannel,
    error,
    loading,
    convertedData: convertOptions(data?.saleChannel?.listSalesChannel),
  };
};

export const useLazySalesChannel = () => {
  const [pagination, { loading, data, error }] = useLazyQuery(SALES_CHANNEL_INPUT_OPTIONS);

  const getSalesChannel = async () => {
    pagination({
      variables: {
        filters: {},
      },
    });
  };

  return {
    data: data?.saleChannel?.listSalesChannel,
    error,
    loading,
    convertedData: convertOptions(data?.saleChannel?.listSalesChannel),
    getSalesChannel,
  };
};

// Danh mục kênh bán cho edit mode của SP: lọc client theo platform của SP (R1) và sắp theo R17.
// Không có platformID (null/undefined/"") thì trả mảng rỗng, KHÔNG trả toàn bộ: hiện kênh của mọi platform là vi phạm R1.
export const useLazySalesChannelsByPlatform = () => {
  const [load, { loading, data, error, refetch, called }] = useLazyQuery(SALES_CHANNEL_WITH_PLATFORM, {
    variables: { filters: {} },
  });

  const allChannels = data?.saleChannel?.listSalesChannel;

  const getChannelsByPlatform = (platformID) => {
    if (platformID === null || platformID === undefined || platformID === "") return [];
    const list = Array.isArray(allChannels) ? allChannels.filter(Boolean) : [];
    const filtered = list.filter((channel) => String(channel?.platformID) === String(platformID));
    return sortSaleChannels(filtered);
  };

  return {
    load,
    refetch,
    called,
    loading,
    error,
    allChannels,
    getChannelsByPlatform,
  };
};
